import { env } from '@/env';
import growthbook from '@/services/growthbook';

export const getFleetTypeRedirectUrl = (fleetTypeSlug?: string, countryCode?: string) => {
    if (!fleetTypeSlug || !countryCode) {
        return undefined;
    }

    if (fleetTypeSlug !== 'car') {
        return undefined;
    }

    const countryCodeLowerCase = countryCode?.toLowerCase();
    if (countryCodeLowerCase === 'au' && growthbook?.isOn('fleet-type-redirect-au-car')) {
        return env.NEXT_PUBLIC_FLEET_TYPE_REDIRECT_AU_CAR_URL;
    }

    if (countryCodeLowerCase === 'nz' && growthbook?.isOn('fleet-type-redirect-nz-car')) {
        return env.NEXT_PUBLIC_FLEET_TYPE_REDIRECT_NZ_CAR_URL;
    }

    return undefined;
};
